<div class="filter-toggle gap-2" *ngIf="showFilters">
  <button (click)="toggleFilters()" hasIcon="icon" [title]="isFiltersCollapsed ? 'Mostrar filtros' : 'Ocultar filtros'" class="cursor-pointer">
    <mat-icon class="cursor-pointer !text-[20px] !size-[20px] text-red-700 material-icons-outlined align-bottom">filter_alt{{ isFiltersCollapsed ? '' : '_off' }}</mat-icon>
  </button>
  <button color="primary" (click)="downloadCSV(filteredItems)" *ngIf="allowDownload" class="cursor-pointer">
    <mat-icon class="cursor-pointer !text-[20px] !size-[20px] text-red-700 material-icons-outlined align-bottom">download</mat-icon>
  </button>
</div>

<!-- ✅ Optional Header -->
<ng-container *ngIf="headerTemplateRef">
  <ng-container *ngTemplateOutlet="headerTemplateRef"></ng-container>
</ng-container>

<div *ngIf="showFilters && !isFiltersCollapsed" class="mb-6 py-4 px-4 mx-auto w-fullrelative border rounded-md border-red-700">

  <!-- ✅ Optional Filters -->
  <form [formGroup]="filterForm" class="filters-form">
    <div class="filters-row">
      <ng-container *ngFor="let field of filterFields">
        <ng-container *ngIf="getControl(field.key) as control">
          <!-- Text -->
          <div class="filter-field" *ngIf="field.type === 'text'">
            <label class="filter-label">{{ field.label }}</label>
            <mat-form-field appearance="fill" class="filter-field">
              <input matInput type="text" [formControl]="control" />
            </mat-form-field>
          </div>

          <!-- Select -->
          <div class="filter-field" *ngIf="field.type === 'select'">
            <label class="filter-label">{{ field.label }}</label>
            <mat-form-field appearance="fill" class="filter-field">
              <mat-select [formControl]="control">
                <mat-option *ngFor="let opt of field.options" [value]="opt.key">{{ opt.value }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Checkbox -->
          <div *ngIf="field.type === 'checkbox'" class="filter-field checkbox-wrapper">
            <mat-checkbox [formControl]="control">
              {{ field.label }}
            </mat-checkbox>
          </div>

          <!-- Range Slider -->
          <ng-container *ngIf="getControl(field.key) as control">
            <div *ngIf="field.type === 'range-slider'" class="filter-field">
              <label class="filter-label">{{ field.label }}</label>
              <div class="range-wrapper">

                <div class="custom-range-wrapper">
                  <div class="thumb-value left"
                       [ngStyle]="{ left: leftThumbPosition + '%' }">
                    {{ rangeValue[0] }}
                  </div>
                  <div class="thumb-value right"
                       [ngStyle]="{ left: rightThumbPosition + '%' }">
                    {{ rangeValue[1] }}
                  </div>

                  <tui-range [formControl]="control"
                             [min]="field.min || 0"
                             [max]="field.max || 5000"
                             [step]="field.step || 1"
                             [segments]="field.segments || 4"></tui-range>

                </div>

                <div class="range-labels">
                  <span>{{ field.min || 0 }}</span>
                  <span>{{ field.max || 5000 }}</span>
                </div>

              </div>
            </div>
          </ng-container>


          <!-- Range inputs -->
          <ng-container *ngIf="getControl(field.key) as control">
            <div *ngIf="field.type === 'range-inputs'" class="filter-field">
              <label class="filter-label">{{ field.label }}</label>
              <div class="filters-row flex-row">
                <mat-form-field appearance="fill" class="filter-range-field" *ngIf="getNestedControl(field.key, 'from') as fromControl">
                  <mat-label>{{ 'COMMON.FROM' | translate }}</mat-label>
                  <input matInput type="number" [formControl]="fromControl" />
                </mat-form-field>
                <mat-form-field appearance="fill" class="filter-range-field" *ngIf="getNestedControl(field.key, 'to') as toControl">
                  <mat-label>{{ 'COMMON.TO' | translate }}</mat-label>
                  <input matInput type="number" [formControl]="toControl" />
                </mat-form-field>
              </div>
            </div>
          </ng-container>

          <!-- Date Range -->
          <div class="filter-field" *ngIf="field.type === 'date-range'">
            <label class="filter-label">{{ field.label }}</label>
            <div class="filter-date-range filter-field">
              <tui-input-date-range class="!rounded-none border-b"
                                    [formControl]="control"
                                    [tuiTextfieldLabelOutside]="true"
                                    [min]="minDate"
                                    [max]="maxDate" />
            </div>
          </div>

        </ng-container>
      </ng-container>
    </div>

    <!-- Botones -->
    <div class="filter-actions">
      <!--<button (click)="applyFilters()">{{ 'COMMON.FILTER.SEARCH' | translate }}</button>-->
      <button mat-button class="clean cursor-pointer" (click)="resetFilters()" type="button">{{ 'COMMON.FILTER.CLEAN' | translate }}</button>
    </div>
  </form>

</div>
<!-- <ng-container *ngIf="headerTemplateRef">
  <ng-container *ngTemplateOutlet="headerTemplateRef"></ng-container>
</ng-container> -->

<!-- ✅ Item List -->
<div class="results">
  <ng-container *ngIf="tableHeaderTemplateRef">
    <ng-container *ngTemplateOutlet="tableHeaderTemplateRef"></ng-container>
  </ng-container>

  <ng-container *ngFor="let item of paginatedItems">
    <div class="" (click)="handleItemClick(item)"
         [style.cursor]="itemClick.observed ? 'pointer' : 'default'">
      <!-- Item Template -->
      <ng-container *ngTemplateOutlet="itemTemplateRef; context: { $implicit: item }"></ng-container>

      <!-- Action Buttons (Edit/Delete/Other) -->
      <div *ngIf="actionsTemplateRef" class="actions flex gap-2">
        <ng-container *ngTemplateOutlet="actionsTemplateRef; context: { $implicit: item }"></ng-container>
      </div>
    </div>
  </ng-container>
</div>

<!-- ✅ Pagination -->
<div class="pagination">
  <button (click)="prevPage()" [disabled]="currentPage === 1" class="cursor-pointer disabled:cursor-not-allowed">‹ Anterior</button>
  <span>Página {{ currentPage }}</span>
  <button (click)="nextPage()" [disabled]="(currentPage * pageSize) >= filteredItems.length" class="cursor-pointer disabled:cursor-not-allowed">Siguiente ›</button>
</div>


<!-- ✅ Optional Footer -->
<ng-container *ngIf="footerTemplateRef">
  <ng-container *ngTemplateOutlet="footerTemplateRef"></ng-container>
</ng-container>

